import { useTranslation } from "react-i18next";
import { Table } from "react-bootstrap";
import { GoThumbsup, GoThumbsdown } from "react-icons/go";
import { IoWarningOutline } from "react-icons/io5";
import { COLOR } from "../../../../../config/constraits";
import { TopicStatistics } from "../../../../topics/types";
import './TopicsClaimTableContent.css';

export default function TopicsClaimTableContent({
    topics,
    onTopicClick,
    centered = false,
}: {
    topics: TopicStatistics[];
    onTopicClick: (topicId: number, sentiment?: 'positive' | 'neutral' | 'negative' | 'alert') => void;
    centered?: boolean;
}) {
    const { t } = useTranslation("claim");

    const valueAlign = centered ? "center" : undefined;

    return (
        <Table responsive className="mt-3 mb-0">
            <thead>
                <tr>
                    <th style={{ backgroundColor: "#F5F5F5", textAlign: "left", border: "none" }}>
                        {t("claim:trendingTopics.labelHeaderTopics")}
                    </th>
                    <th style={{ whiteSpace: "nowrap", backgroundColor: "#F5F5F5", border: "none", textAlign: valueAlign }}>
                        {t("claim:trendingTopics.labelHeaderConversation")}
                    </th>
                    <th className="table-header-icon" style={{ textAlign: valueAlign }}>
                        <GoThumbsup style={{ color: COLOR.VERD, fontSize: "24px" }} />
                    </th>
                    <th className="table-header-white-space" />
                    <th className="table-header-icon" style={{ textAlign: valueAlign }} />
                    <th className="table-header-white-space" />
                    <th className="table-header-icon" style={{ textAlign: valueAlign }}>
                        <GoThumbsdown style={{ color: COLOR.VERMELL, fontSize: "24px" }} />
                    </th>
                    <th className="table-header-white-space" />
                    <th className="table-header-icon" style={{ textAlign: valueAlign }}>
                        <IoWarningOutline style={{ fontSize: "24px" }} />
                    </th>
                </tr>
            </thead>
            <tbody>
                {topics.map((topic, index) => (
                    <tr key={index}>
                        <td className="table-row-cell"
                            style={{
                                textAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                            onClick={() => onTopicClick(topic.topicId)}
                        >
                            {topic.topicName}
                        </td>
                        <td className="table-row-cell" style={{ textAlign: valueAlign }}>{topic.percentage?.toFixed()}%</td>
                        <td className="table-row-cell" style={{ backgroundColor: COLOR.VERD_LIGHT, textAlign: valueAlign }}
                            onClick={() => onTopicClick(topic.topicId, 'positive')}>
                            {topic.positiveComments}
                        </td>
                        <td />
                        <td className="table-row-cell" style={{ backgroundColor: COLOR.TARONJA, textAlign: valueAlign }}
                            onClick={() => onTopicClick(topic.topicId, 'neutral')}>
                            {topic.neutralComments}
                        </td>
                        <td />
                        <td className="table-row-cell" style={{ backgroundColor: COLOR.VERMELL_LIGHT, textAlign: valueAlign }}
                            onClick={() => onTopicClick(topic.topicId, 'negative')}>
                            {topic.negativeComments}
                        </td>
                        <td />
                        <td className="table-row-cell"
                            style={{
                                backgroundColor: topic.urgency > 0 ? COLOR.VERMELL_DARK : "white",
                                color: topic.urgency > 0 ? "white" : "black",
                                textAlign: valueAlign,
                            }}
                            onClick={() => onTopicClick(topic.topicId, 'alert')}
                        >
                            {topic.urgency}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}